// extracted by mini-css-extract-plugin
export default {"item":"_6c2e0b247e552773","date":"a6c88dcbc485ea95","name":"_3fa7f8f29178a662","comment":"_5b18bccb6ac6a55d"};